import InlineImageViewState from '../schema/InlineImageViewState';
import ImageStatus from '../schema/ImageStatus';
import setImageState from '../actions/setImageState';
import getImageDimensionsFromFile from './getImageDimensionsFromFile';
import insertPlaceholderImage from './insertPlaceholderImage';
import { EditorViewState } from 'owa-editor';
import { lazyLogImageUpload, lazyLogImageLoadError } from 'owa-inline-image-loader';
import { AttachmentFileType, AttachmentFile } from 'owa-attachment-file-types';
import { CONTEXT_UPLOAD } from './constants';
import PastedBase64InlineImageFile from '../schema/PastedBase64InlineImageFile';

const ERROR_UNSUPPORTED_FILETYPE = 'UnsupportedFileType';

// The default size for placeholder div
const DEFAULT_PLACEHOLDER_WIDTH = 500;
const DEFAULT_PLACEHOLDER_HEIGHT = 400;

export default function processInlineImageBeforeUpload(
    viewState: InlineImageViewState,
    editorViewState: EditorViewState,
    temporaryId: string,
    file: AttachmentFile
) {
    lazyLogImageUpload
        .import()
        .then(imageUploadLogger => imageUploadLogger(file.fileType.toString()));

    if (file.fileType == AttachmentFileType.Base64InlineImage) {
        setImageState(
            viewState,
            temporaryId,
            ImageStatus.PlaceholderShown,
            (file as PastedBase64InlineImageFile).imageNode
        );
    } else if (file.fileType == AttachmentFileType.ExpirableBase64InlineImage) {
        setImageState(viewState, temporaryId, ImageStatus.Started);
        insertPlaceholderImage(
            viewState,
            editorViewState,
            temporaryId,
            file.name,
            DEFAULT_PLACEHOLDER_WIDTH,
            DEFAULT_PLACEHOLDER_HEIGHT
        );
    } else if (file.fileType == AttachmentFileType.Local) {
        setImageState(viewState, temporaryId, ImageStatus.Started);

        getImageDimensionsFromFile(file.fileObject).then(dim => {
            insertPlaceholderImage(
                viewState,
                editorViewState,
                temporaryId,
                file.name,
                dim.width,
                dim.height
            );
        });
    } else {
        lazyLogImageLoadError
            .import()
            .then(imageLoadErrorLogger =>
                imageLoadErrorLogger(
                    file.fileType.toString() /* type */,
                    '' /* howLoad */,
                    ERROR_UNSUPPORTED_FILETYPE /* error */,
                    '' /* statusCode */,
                    CONTEXT_UPLOAD /* context */
                )
            );
    }
}
